import {
  Outlet, useOutlet, useNavigate, useLocation,
} from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';

import Datapanel from '@App/components/Datapanel/Datapanel';
import Map from '@App/components/Map/Map';

import {
  usePreserveRightMapAnchorOnResize,
  useMoveLeftMapControlsOnResize,
} from './map-layout.hooks';

import './map-layout.css';

function MapLayout() {
  const outlet = useOutlet();

  const navigate = useNavigate();
  const location = useLocation();
  const mapWrapperRef = useRef();
  const [showDatapanel, setShowDatapanel] = useState(location.pathname !== '/');
  const [map, setMap] = useState();

  usePreserveRightMapAnchorOnResize(map, showDatapanel);
  useMoveLeftMapControlsOnResize(map, showDatapanel);

  useEffect(() => {
    if (!mapWrapperRef?.current) return undefined;

    if (!showDatapanel) mapWrapperRef?.current.classList.add('map-layout__map--full-width');

    const timeoutId = setTimeout(() => {
      if (!showDatapanel) navigate('/');
      else mapWrapperRef?.current.classList.remove('map-layout__map--full-width');
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [navigate, showDatapanel]);

  return (
    <div className={`map-layout map-layout--${showDatapanel ? 'show-datapanel' : 'hide-datapanel'}`}>
      {outlet && (
        <div className="map-layout__datapanel">
          <Datapanel isOpen={showDatapanel} setIsOpen={setShowDatapanel}>
            <Outlet context={{ map }} />
          </Datapanel>
        </div>
      )}
      <div className="map-layout__map map-layout__map--full-width" ref={mapWrapperRef}>
        <Map map={map} setMap={setMap} />
      </div>
    </div>
  );
}

export default MapLayout;
